/**
 * Database type.
 */
export type DatabaseType =
    | "aurora-mysql"
    | "aurora-postgres"
    | "better-sqlite3"
    | "capacitor"
    | "cockroachdb"
    | "cordova"
    | "expo"
    | "mariadb"
    | "mongodb"
    | "mssql"
    | "mysql"
    | "nativescript"
    | "oracle"
    | "postgres"
    | "react-native"
    | "sap"
    | "spanner"
    | "sqljs"
